import React, { forwardRef } from 'react';

import type { HeadwearColorsNullableParameter, HeadwearStatesNullableParameter } from '@vlabs/api/luna-api/model';
import { EVENT_ENUMS } from '@vlabs/api-bindings/src/luna-client/constants';

import { ColorGridFilter } from '@vlabs/monokit/shared/ui/color-grid-filter';
import { OptionsFilter } from '@vlabs/monokit/shared/ui/options-filter';
import type { PopoverWithButtonProps } from '@vlabs/monokit/shared/ui/popovers';
import { PopoverWithButton } from '@vlabs/monokit/shared/ui/popovers';

import { useEventListFiltersTranslation } from '../../i18n';
import { useEventListFilters } from '../../useEventListFilters';
import st from '../popovers.module.sass';

function HeadwearFilterPopover(
  props: PopoverWithButtonProps,
  ref: React.ForwardedRef<HTMLDivElement>,
): React.JSX.Element {
  const { t } = useEventListFiltersTranslation();
  const { filters, updateFilters } = useEventListFilters();

  const selectedColors = filters.headwear_apparent_colors ?? [];
  const selectedStates = filters.headwear_states ?? [];

  const reset = () => updateFilters({
    headwear_apparent_colors: undefined,
    headwear_states: undefined,
  });

  return (
    <PopoverWithButton
      {...props}
      isButtonDisabled={
        filters.headwear_apparent_colors === undefined
        && filters.headwear_states === undefined
      }
      onClickReset={reset}
      ref={ref}
    >
      <div className={st.Subtitle}>{t('headwear_states')}</div>
      <div className={st.CheckboxContainer}>
        <OptionsFilter
          isSearchable={false}
          name="headwear_states"
          onChange={(value) => updateFilters({
            headwear_states: value.length > 0
              ? (value as unknown as HeadwearStatesNullableParameter)
              : undefined,
          })}
          options={EVENT_ENUMS.UPPER_BODY.HEADWEAR.raw}
          value={selectedStates as unknown as string[]}
        />
      </div>
      <div className={st.Divider} />
      <ColorGridFilter
        label={t('headwear_color')}
        onChange={(value) => updateFilters({
          headwear_apparent_colors: value.length > 0
            ? (value as unknown as HeadwearColorsNullableParameter)
            : undefined,
        })}
        options={EVENT_ENUMS.UPPER_BODY.HEADWEAR_COLORS.raw}
        value={selectedColors}
      />
    </PopoverWithButton>
  );
}

const HeadwearFilterPopoverWithRef = forwardRef(HeadwearFilterPopover);
export { HeadwearFilterPopoverWithRef as HeadwearFilterPopover };
